// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"96acc909","186":"a8d01519","453":"4a7cd015","558":"3bce78e7","629":"30ccdd54","671":"814bb003","679":"61d5047b","753":"ac318d0c","817":"e78a936b","838":"a2a340b8","842":"0b79ea1f","888":"c342718d","896":"9770257e","970":"2c482339"}[chunkId] + ".chunk.js";
};